export default "__VITE_ASSET__Y8uSt$yX__"